import React from 'react';
import { Spin, SpinProps } from 'antd';

export const CenterSpin = (props: SpinProps) => {
  return (
    <div style={{ position: 'absolute', top: '35%', left: '46%' }}><Spin {...props} /></div>
  )
}
